import * as TabsPrimitive from '@radix-ui/react-tabs'
import { styled } from '../../../../lib/stitches'

const ACTIVE_COLOR = '#7266F9'

const Root = styled(TabsPrimitive.Root)
const Content = styled(TabsPrimitive.Content, {})
const List = styled(TabsPrimitive.List, {
  display: 'flex'
})
const Trigger = styled(TabsPrimitive.Trigger, {
  all: 'unset',
  padding: '16px',
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: '$bold',
  whiteSpace: 'nowrap',
  letterSpacing: '-0.02em',
  lineHeight: '18px',
  color: 'rgb(0,0,0)',
  '&:hover': { color: ACTIVE_COLOR },
  '&[data-state="active"]': {
    color: ACTIVE_COLOR,
    boxShadow: 'inset 0 -1px 0 0 currentColor, 0 1px 0 0 currentColor'
  },
  variants: {
    weight: {
      medium: {
        fontWeight: '$medium'
      }
    },
    font: {
      dm: {
        fontFamily: '$dm'
      }
    },
    dark: {
      true: {
        color: '$gray13',
        opacity: '80%',
        '&:hover': { opacity: '100%', color: '$gray13' },
        '&[data-state="active"]': {
          opacity: '100%',
          color: '$gray13'
        }
      }
    }
  }
})

const Icon = styled('div', {
  flexShrink: 0,
  marginRight: '8px',
  color: 'inherit',
  '& > *': {
    width: '20px',
    height: '20px'
  }
})

export default {
  Root,
  Content,
  List,
  Trigger,
  Icon
}
